import { useMemo } from 'react';
import { usePrioritizationTaskStore } from '../stores/prioritization/prioritizationTaskStore';
import { usePriorityProposalStore } from '../stores/prioritization/priorityProposalStore';
import { useMyTasksArchive } from './useMyTasksArchive';
import { useCatchballQueueArchive } from './useCatchballQueueArchive';
import { useCatchballBallInCourtData } from './useCatchballBallInCourtData';
import { getMyTasksQueueMetrics } from '../lib/myTasksQueueMetrics';

/**
 * Navigation / sidebar counts aligned with the Tasks page default queue:
 * open assignments not hidden + Catchball rows not hidden (+ proposals for sidebar badge).
 */
export function useMyTasksNavQueueMetrics(
  userId: string | null | undefined,
  workspaceId: string | null | undefined
) {
  const tasks = usePrioritizationTaskStore(s => s.tasks);
  const proposals = usePriorityProposalStore(s => s.proposals);
  const { archivedIds } = useMyTasksArchive(userId, workspaceId);
  const { hiddenCatchballIds } = useCatchballQueueArchive(userId, workspaceId);
  const { activeTurns, filteredLegacyLoops } = useCatchballBallInCourtData(userId ?? null);

  return useMemo(
    () =>
      getMyTasksQueueMetrics({
        tasks,
        userId,
        archivedIds,
        hiddenCatchballIds,
        activeTurns,
        filteredLegacyLoops,
        proposals,
      }),
    [tasks, userId, archivedIds, hiddenCatchballIds, activeTurns, filteredLegacyLoops, proposals]
  );
}
